export type NonCardPaymentMethod = 'paypal' | 'utrust' | 'free';
export type CardPaymentMethod = 'firstdata' | 'trustpayments' | 'cashflows' | 'checkout';
export type ChosenPaymentMethod = 'card' | NonCardPaymentMethod;
export type PaymentGatewayName = CardPaymentMethod | NonCardPaymentMethod;

export class PaymentSubmission {
  returnPath?: string;
  preferredProcessor: PaymentGatewayName;
  paymentCardId?: string | null;
  cardNumber?: string | null;
  expMonth?: string | null;
  expYear?: string | null;
  securityCode?: string | null;
  flags?: string[];
}
